import React from 'react';

const BrFlag = ({ className }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true" focusable="false">
    <rect width="24" height="16" fill="#009B3A" />
    <path d="M12 2.2 21.6 8 12 13.8 2.4 8Z" fill="#FEDF00" />
    <circle cx="12" cy="8" r="3.4" fill="#002776" />
  </svg>
);

export default BrFlag;
